import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../../components/Icon";
import { showSuccess, showError } from "../../../../services/toast.service";

const Panel = ({ selectedAttendances = [], onRemoveSelected, onClearSelection, onSendSignatureInvitations, sendingInvitations }) => {
  const handleRemoveSelected = async () => {
    if (!selectedAttendances.length) return;
    
    try {
      await onRemoveSelected(selectedAttendances);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la suppression des attendances');
      console.error(error);
    }
  };

  const handleSendSignatureInvitations = async () => {
    if (!selectedAttendances.length) return;
    
    try {
      await onSendSignatureInvitations(selectedAttendances);
    } catch (error) {
      showError('Erreur lors de l\'envoi des invitations');
      console.error(error);
    }
  };

  if (!selectedAttendances.length) return null;

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedAttendances.length} attendance{selectedAttendances.length > 1 ? 's' : ''} sélectionnée{selectedAttendances.length > 1 ? 's' : ''}</span>
      </div>
      <div className={styles.btns}>
        <button 
          className={cn("button-blue", styles.button)} 
          onClick={handleSendSignatureInvitations}
          disabled={sendingInvitations}
        >
          <Icon name="mail" size="24" />
          <span>{sendingInvitations ? 'Envoi en cours...' : 'Envoyer invitations de signature'}</span>
        </button>
        <button className={cn("button-stroke-red", styles.button)} onClick={handleRemoveSelected}>
          <Icon name="trash" size="24" />
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  );
};

export default Panel;
